"use strict";

define('libs/scroll.handler',['underscore', 'backbone', 'jquery'], function (_, Backbone) {
  var ScrollHandler = Backbone.View.extend({
    scrollToTop: function scrollToTop() {
      this.$el.scrollTop(0);
      return this;
    },
    delegateEvents: function delegateEvents(ev) {
      Backbone.View.prototype.delegateEvents.apply(this, arguments);
      var self = this;
      var suffix = '.delegateEvents' + this.cid;
      this.$el.on('scroll' + suffix, function () {
        if (self._didRequestFrame) {
          return;
        }
        self._didRequestFrame = true;
        window.requestAnimationFrame(function () {
          self._didRequestFrame = false;
          self.processScroll();
        });
      });
    },
    processScroll: function processScroll() {
      var scrollTop = this.$el.scrollTop(),
        height = this.$el.height(),
        scrollHeight = this.el.scrollHeight;
      if (scrollTop + height >= scrollHeight) {
        this.trigger('scroll:bottom');
      } else if (scrollTop === 0) {
        this.trigger('scroll:top');
      }
    }
  });
  return ScrollHandler;
});

